import React from 'react'
import { router, usePage } from '@inertiajs/react'
import {
  Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import StatusBadge from '../../../../components/ui/StatusBadge'
import FormattedCurrency from '../../../../components/ui/FormattedCurrency'

Index.layout = (page) => <AppShell>{page}</AppShell>

export default function Index({ property, special_levies }) {
  const { props } = usePage()
  const tenant = props.tenant || {}

  return (
    <Box>
      <PageHeader
        title="Sonderumlagen"
        breadcrumbs={[
          { label: 'Sonderumlagen' },
        ]}
        actions={
          <Button variant="contained" startIcon={<AddIcon />}
            onClick={() => router.visit(`/m/${tenant.slug}/properties/${property.id}/special_levies/new`)}
            data-testid="new-levy-btn">
            Neue Sonderumlage
          </Button>
        }
      />

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Betrag</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Beschluss</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Fällig</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Raten</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {special_levies.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Sonderumlagen.</Typography>
                </TableCell>
              </TableRow>
            )}
            {special_levies.map((levy) => (
              <TableRow key={levy.id} hover sx={{ cursor: 'pointer' }}
                onClick={() => router.visit(`/m/${tenant.slug}/properties/${property.id}/special_levies/${levy.id}`)}
                data-testid={`levy-row-${levy.id}`}>
                <TableCell><Typography variant="body2" fontWeight={500}>{levy.name}</Typography></TableCell>
                <TableCell align="right">{levy.amount ? <FormattedCurrency value={levy.amount} /> : '–'}</TableCell>
                <TableCell>{levy.resolution_number ? `#${levy.resolution_number}` : '–'}</TableCell>
                <TableCell>{levy.due_date}</TableCell>
                <TableCell>{levy.installments}</TableCell>
                <TableCell><StatusBadge type="special_levy_status" value={levy.status} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
